import secureLocalStorage from "react-secure-storage";
import {RecType} from "../pages/Recommendations";

export const setUsersLastRecType = (option: RecType): void => {
    try {
        secureLocalStorage.setItem("lastRecType", option);
    } catch {
        console.log("Secure storage may be down")
    }
}

export const getUsersLastRecType = (): RecType | undefined => {
    try {
        const recType = secureLocalStorage.getItem("lastRecType");

        if (recType === RecType.ARTISTS || recType === RecType.EVENTS) {
            return recType as RecType;
        }
        return undefined;
    } catch (error) {
        return undefined;
    }
};


